import { ArrowLeftOutlined, DashboardOutlined } from "@ant-design/icons";
import {
  Button,
  Divider,
  Flex,
  message,
  Modal,
  Progress,
  Select,
  Space,
  Typography
} from "antd";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { Html5QrcodeScanner } from "html5-qrcode";
import { setUser } from "../redux/slice/user";
import {
  collection,
  doc,
  addDoc,
  updateDoc,
  increment,
  serverTimestamp,
  getDoc,
  runTransaction,
  query,
  where,
  getDocs
} from "firebase/firestore";
import { useSelector, useDispatch } from "react-redux";
import { db_fire } from "../firebase";
import Loading from "../components/Loading";
import {getScannerType} from "../utils/other"
import { createFreeMealCoupon } from "../firebase/createCoupon";



const { Text } = Typography;

export default function Reward() {
  const [searchParams] = useSearchParams();
  const { userDetails } = useSelector(state => state.user);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasD = searchParams.has("d");
  const d = searchParams.get("d");

  const scannerRef = useRef(null);
  const [scanned, setScanned] = useState(false);
  const [loading, setloading] = useState(false);

  const hasCheckedCouponRef = useRef(false);

  useEffect(() => {
    if (hasCheckedCouponRef.current) return;
    hasCheckedCouponRef.current = true;

    if (userDetails.rewardCount >= 10 && !d) {
      askPlatformForCoupon();
    }
  }, []);


  const startScanner = () => {

    scannerRef.current = new Html5QrcodeScanner(
      "qr-reader",
      { fps: 10, qrbox: 250 },
      false
    );

    scannerRef.current.render(
      async (decodedText) => {

        setScanned(true);
        handleCheckRewardData(decodedText)

        // stop scanner after success
        scannerRef.current.clear();
      },
      () => {
        // ignore scan errors
      }
    );
  };

const handleCheckRewardData = async (qr, withURL = false) => {
  const device = getScannerType();

  // 🛑 STOP HERE — do not continue
  if (device === "ios_scanner" && !userDetails.isLoggedIn && withURL) {
    modal.confirm({
      title: "Save Your Reward",
      content:
        " iPhone QR scans open in a temporary browser. Open in Safari or add your email to save your reward.",
      okText: "Continue Here",
      cancelText: "Open in Safari",
      onOk: () => processReward(qr),   // ✅ proceed only on OK
      onCancel: () => {
        window.location.href = `https://www.kamuska.in/reward?d=${qr}`;
      },
    });

    return; // 🔴 IMPORTANT: stop execution here
  }

  // ✅ Normal flow (Android / logged-in / browser)
  processReward(qr);
};

const processReward = async (qr) => {
  if (userDetails.rewardCount >= 10) {
    message.warning("Please create your free meal coupon first");
    return askPlatformForCoupon();
  }

  try {
    qr = qr.replace(/https?:\/\/(www\.)?kamuska\.in\/reward\?d=/, "");
    setloading(true);

    const rewardsRef = collection(db_fire, "rewards");
    const q = query(rewardsRef, where("rewardCode", "==", qr));
    const rewardSnap = await getDocs(q);

    if (rewardSnap.empty) {
      modal.error({ title: "Invalid QR", content: "This reward QR is not valid." });
      return;
    }

    const rewardDoc = rewardSnap.docs[0];
    const rewardRef = rewardDoc.ref;

    if (rewardDoc.data().usedBy !== null) {
      modal.warning({
        title: "Reward Already Used",
        content: "This reward has already been redeemed.",
      });
      return;
    }

    let userId = userDetails._id;
    let updatedRewardCount = 1;

    await runTransaction(db_fire, async (tx) => {
      const freshRewardSnap = await tx.get(rewardRef);

      if (!freshRewardSnap.exists()) throw new Error("Invalid reward");
      if (freshRewardSnap.data().usedBy !== null)
        throw new Error("Reward already used");

      if (!userDetails.isLoggedIn) {
        const userRef = doc(collection(db_fire, "users"));

        tx.set(userRef, {
          name: `GUEST ${Date.now().toString().slice(-5)}`,
          email: "",
          rewardCount: 1,
          isGuest: true,
          isLoggedIn: true,
          createdAt: serverTimestamp(),
          lastRewardAt: serverTimestamp(),
        });

        userId = userRef.id;
        updatedRewardCount = 1;

        dispatch(setUser({
          _id: userId,
          name: `GUEST ${Date.now().toString().slice(-5)}`,
          rewardCount: 1,
          isLoggedIn: true,
        }));
      } else {
        const userRef = doc(db_fire, "users", userId);

        tx.update(userRef, {
          rewardCount: increment(1),
          lastRewardAt: serverTimestamp(),
        });

        updatedRewardCount = (userDetails.rewardCount || 0) + 1;

        dispatch(setUser({ rewardCount: updatedRewardCount }));
      }

      tx.update(rewardRef, {
        status: "used",
        usedBy: userId,
      });
    });

    if (updatedRewardCount >= 10) {
      return askPlatformForCoupon();
    }

    modal.success({
      title: "Reward Collected! 🎉",
      content: `You now have ${updatedRewardCount} reward(s).`,
    });

    localStorage.removeItem("qr_redirect_done");

    setTimeout(() => {
      if (d) window.location.replace("/");
    }, 3000);

  } catch (error) {
    modal.error({
      title: "Invalid or Used QR",
      content: error.message || "This reward QR is invalid or already used.",
    });
  } finally {
    setloading(false);
  }
};


  const hasRunRef = useRef(false);
 

  useEffect(() => {
    localStorage.removeItem("HTML5_QRCODE_DATA");
    startScanner();
    if (hasRunRef.current) return;
    hasRunRef.current = true;

    if (hasD && !d) {
      message.error("Invalid QR");
      return;
    }

    if (d) {
      handleCheckRewardData(d,true);
    }

    return () => {
      scannerRef.current?.clear().catch(() => { });
    };
  }, []);


  const scanAgain = () => {
    setScanned(false);
    startScanner();
  };

  const [modal, contextHolder] = Modal.useModal();

  const handleCreateCoupon = async (platform) => {
    try {
      Modal.destroyAll();
      setloading(true);

      // 1️⃣ create coupon
      await createFreeMealCoupon(userDetails._id, platform);

      // 2️⃣ reset reward count in Firestore
      const userRef = doc(db_fire, "users", userDetails._id);

      await updateDoc(userRef, {
        rewardCount: 0,
        couponPending: false,
        lastRewardResetAt: serverTimestamp(),
      });

      // 3️⃣ refresh redux user (instant UI update)
      dispatch(setUser({
        rewardCount: 0,
        couponPending: false,
      }));


      message.success("🎉 Coupon created! Start collecting rewards again.");

    } catch (err) {
      message.error(err.message || "Failed to create coupon");
    } finally {
      setloading(false);
    }
  };


  const askPlatformForCoupon = () => {
    modal.info({
      closable: false,
      okText: "Skip",
      maskClosable: false,
      title: "🎉 Free Meal Unlocked!",
      content: (
        <Select
          placeholder="Select platform"
          style={{ width: "100%" }}
          onChange={handleCreateCoupon}
          options={[
            { label: "Ola", value: "ola" },
            { label: "Zomato", value: "zomato" },
            { label: "Swiggy", value: "swiggy" },
            { label: "Kamuska", value: "kamuska" },
          ]}
        />
      ),
    });
  };


  return (
    <>
      {loading && <Loading />}
      {/* Title */}
      <Flex align="center" justify="space-between">
        <Space>
          {!d && (
            <ArrowLeftOutlined
              onClick={() => navigate(-1)}
              style={{ marginRight: 10 }}
            />
          )}
          <Text strong style={{ textTransform: "capitalize" }}>
            Scan Reward QR
          </Text>
        </Space>
        {d && (<Text italic><Link to="/" replace={true}>Dashboard</Link></Text>)}
      </Flex>

      <br />

      {/* Sub title */}
      <Text type="secondary">
        Scan the QR code printed inside your order box to collect rewards.
      </Text>

      {/* Progress */}
      <div style={{ marginTop: 5 }}>
        <Progress
          percent={(userDetails.rewardCount / 10) * 100}
          showInfo={false}
          strokeColor={userDetails.rewardCount >= 10 ? "green" : "#1677ff"}
        />
        <Flex justify="space-between">
          <Text strong style={{ fontSize: 12, color: "#8c8c8c" }}>
            Rewards collected: {userDetails.rewardCount} / 10
          </Text>
          {userDetails.rewardCount >= 10 && <Text italic onClick={_ => askPlatformForCoupon()} style={{ fontSize: 12, color: "#1677ff", cursor: "pointer" }}>
            Redeem Coupon
          </Text>}
        </Flex>
      </div>

      <Divider />

      {/* QR Scanner */}
      <div id="qr-reader" style={{ width: "100%" }} />

      {/* Scan Again Button */}
      {scanned && (
        <Button
          type="primary"
          block
          style={{ marginTop: 16 }}
          onClick={scanAgain}
        >
          Scan Again
        </Button>
      )}

      {/* Footer text */}
      <Text italic style={{ display: "block", marginTop: 16 }}>
        QR inside order box • Collect rewards • 10 meals = 1 FREE
      </Text>

      <Text type="secondary" style={{ fontSize: 12 }}>
        Free meal coupon can be used on Kamuska, Swiggy, or Zomato after 10 rewards.
      </Text>
      {/* after scanned reward */}
      {contextHolder}
    </>
  );
}
